/**
 * Servicio para manejar la duplicación de órdenes
 * Utiliza localStorage para persistir datos entre navegaciones
 */

export interface DuplicateOrderData {
  orderInfo: {
    reference: string;
    store: string;
    paymentMethod: string;
  };
  shippingData: {
    customerName: string;
    customerPhone: string;
    customerEmail: string;
    address1: string;
    address2: string;
    postalCode: string;
    city: string;
    province: string;
    country: string;
    countryId?: string;
  };
  products: {
    id: number;
    name: string;
    code: string;
    image: string;
    price: number;
    quantity: number;
    type: 'product' | 'pack';
    pack_id: number | null;
  }[];
}

const STORAGE_KEY = 'duplicate_order_data';

export class DuplicateOrderService {
  /**
   * Guarda los datos de la orden para duplicación
   */
  static saveDuplicateData(data: DuplicateOrderData): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving duplicate order data:', error);
    }
  }

  /**
   * Obtiene los datos guardados para duplicación
   */
  static getDuplicateData(): DuplicateOrderData | null {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error getting duplicate order data:', error);
      return null;
    }
  }

  /**
   * Limpia los datos de duplicación
   */
  static clearDuplicateData(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing duplicate order data:', error);
    }
  }

  /**
   * Verifica si hay datos de duplicación disponibles
   */
  static hasDuplicateData(): boolean {
    return localStorage.getItem(STORAGE_KEY) !== null;
  }
}
